import React from "react";
import { object } from "prop-types";
import get from "lodash/get";
import { connect } from "react-redux";

import { toBanglaNum } from "../../utils/utils";

import "./imageNumber.m.css";

const ImageNumber = ({ element, imageElements, publisherAttributes }) => {
  const checkingImageNumber = (id) => {
    const imageNumber = imageElements.findIndex((item) => item.id === id);
    return imageNumber + 1;
  };
  return (
    <React.Fragment>
      <div styleName="wrapper">
        {`${
          publisherAttributes.lang === "en"
            ? checkingImageNumber(element.id)
            : toBanglaNum(checkingImageNumber(element.id))
        } / ${publisherAttributes.lang === "en" ? imageElements.length : toBanglaNum(imageElements.length)}`}
      </div>
    </React.Fragment>
  );
};

ImageNumber.propTypes = {
  element: object,
  imageElements: object,
  publisherAttributes: object,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
});

export default connect(mapStateToProps, "")(ImageNumber);
